import { flattenDeep } from 'lodash';

export * from './authenticate';
export * from './authorize';
export * from './newRelic';
export * from './storeRouteQuery';

// default export is function to chain multiple guards

function shouldContinue(nextArg) {
  return !nextArg.redirect;
}

function mutateOrReplaceRoute(to, nextArg) {
  return nextArg.name || nextArg.path
    ? nextArg
    : Object.assign({}, to, nextArg);
}

function evaluateGuards(guards, to, from, next) {
  const guardsLeft = guards.slice(0); // clone the array so we do not accidentally modify it
  const nextGuard = guardsLeft.shift();

  if (nextGuard === undefined) {
    next();
    return;
  }

  nextGuard(to, from, nextArg => {
    if (nextArg === undefined) {
      evaluateGuards(guardsLeft, to, from, next);
      return;
    }

    nextArg = mutateOrReplaceRoute(to, nextArg);

    if (shouldContinue(nextArg)) {
      evaluateGuards(guardsLeft, nextArg, from, next);
    } else {
      next(nextArg);
    }
  });
}

export default function(...args) {
  args = flattenDeep(args);

  return (to, from, next) => evaluateGuards(args, to, from, next);
}
